import { useState, useEffect } from 'react'
import { supabase } from '../supabase'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    // Supabase handles the token from URL automatically
    // when the user clicks the email link
  }, [])

  const handleReset = async () => {
    setError('')
    if (password.length < 8) { setError('Password must be at least 8 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true)
    const { error: err } = await supabase.auth.updateUser({ password })
    setLoading(false)
    if (err) { setError(err.message); return }
    setDone(true)
  }

  return (
    <div style={{ minHeight: '100vh', background: '#080808', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: "'Montserrat', sans-serif" }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/SYNINN_bg_remove_logo.png" alt="SYNINN" style={{ height: 100, mixBlendMode: 'screen' }} />
          <div style={{ fontFamily: 'serif', fontSize: 24, color: '#C9A84C', letterSpacing: 3, marginTop: 8 }}>SYNINN</div>
        </div>
        <div style={{ background: '#0f0f0f', border: '1px solid #1e1e1e', borderRadius: 16, padding: 32 }}>
          {!done ? (
            <>
              <div style={{ fontFamily: 'serif', fontSize: 20, color: '#fff', marginBottom: 6 }}>Set New Password</div>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 24 }}>Enter your new password below</div>

              {error && <div style={{ color: '#ff6b6b', fontSize: 13, marginBottom: 16, padding: '10px 14px', background: '#ff6b6b15', borderRadius: 8 }}>{error}</div>}

              <div style={{ marginBottom: 14 }}>
                <label style={{ color: '#888', fontSize: 13, marginBottom: 4, display: 'block' }}>New Password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 8 characters"
                  style={{ width: '100%', padding: '12px 16px', borderRadius: 10, border: '1px solid #1e1e1e', background: '#111', color: '#fff', fontSize: 15, fontFamily: 'Montserrat, sans-serif', boxSizing: 'border-box', outline: 'none' }} />
              </div>
              <div style={{ marginBottom: 20 }}>
                <label style={{ color: '#888', fontSize: 13, marginBottom: 4, display: 'block' }}>Confirm Password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password"
                  style={{ width: '100%', padding: '12px 16px', borderRadius: 10, border: '1px solid #1e1e1e', background: '#111', color: '#fff', fontSize: 15, fontFamily: 'Montserrat, sans-serif', boxSizing: 'border-box', outline: 'none' }} />
              </div>
              <button onClick={handleReset} disabled={loading}
                style={{ width: '100%', padding: '13px', background: '#C9A84C', color: '#080808', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'Montserrat, sans-serif', opacity: loading ? 0.7 : 1 }}>
                {loading ? 'Saving...' : 'Set New Password'}
              </button>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>✅</div>
              <div style={{ fontFamily: 'serif', fontSize: 20, color: '#fff', marginBottom: 8 }}>Password Updated</div>
              <div style={{ fontSize: 13, color: '#888', marginBottom: 24 }}>Your password has been changed successfully.</div>
              <a href="/" style={{ display: 'block', width: '100%', padding: '13px', background: '#C9A84C', color: '#080808', textDecoration: 'none', borderRadius: 10, fontSize: 14, fontWeight: 600, textAlign: 'center', fontFamily: 'Montserrat, sans-serif', boxSizing: 'border-box' }}>
                Go to SYNINN
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}